export const statusKey = {
  booked: 'booked',
  unbooked: 'unbooked',
  archived: 'archived',
  all: 'all',
}

export const statuses = [
  { name: $localize`Archived`, value: statusKey.archived },
  { name: $localize`Booked`, value: statusKey.booked },
  { name: $localize`Unbooked`, value: statusKey.unbooked },
]

export const interactionType = [
  { name: $localize`Comment`, value: 'comment' },
  { name: $localize`Meeting`, value: 'meeting' },
  { name: $localize`Phone Call`, value: 'phone call' },
]
